const time = {
  "周": "semana(s) ",
  "天": "día(s)",
  "小时": "hora(s) ",
  "分钟": "minuto(s)",
  "刚刚": "Ahora mismo",
  "前": " hace",
  "昨天": "Ayer",
  "星期一": "Lunes",
  "星期二": "Martes",
  "星期三": "Miércoles",
  "星期四": "Jueves",
  "星期五": "Viernes",
  "星期六": "Sábado",
  "星期日": "Domingo",
  "一月": "Enero",
  "二月": "Febrero",
  "三月": "Marzo",
  "四月": "Abril",
  "五月": "Mayo",
  "六月": "Junio",
  "七月": "Julio",
  "八月": "Agosto",
  "九月": "Septiembre",
  "十月": "Octubre",
  "十一月": "Noviembre",
  "十二月": "Diciembre",
  "一": "Lun",
  "二": "Mar",
  "三": "Mié",
  "四": "Jue",
  "五": "Vie",
  "六": "Sáb",
  "日": "Dom",
}

export default time;
